import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Auth
export const signInOrganService = (data) => {
  return http.post(`${base_url}/console_organization/`, JSON.stringify(data));
};
// End Auth

// Start Order
export const getOrdersOrganService = (params) => {
  return http.get(`${base_url}/api/organization_orders/`, { params });
};

export const getOrderOrganService = (id) => {
  return http.get(`${base_url}/api/organization_orders/${id}`);
};
// End Order
